// import React from "react";
// import { Link } from "react-router-dom";
// import {
//   FiHome,
//   FiEdit,
//   FiTool,
//   FiList,
//   FiInfo,
//   FiFileText,
//   FiShield,
//   FiX,
//   FiLogOut,
// } from "react-icons/fi";

// const ProfileSidebarMenu = ({ isSidebarOpen, toggleSidebar }) => {
//   return (
//     <>
    
//       {isSidebarOpen && (
//         <div
//           className="fixed inset-0 bg-black bg-opacity-50 z-30 transition-opacity"
//           onClick={toggleSidebar}
//         ></div>
//       )}

   
//       <div
//         className={`fixed inset-y-0 right-0 z-40 w-3/4 max-w-sm bg-background-back2 p-6 shadow-lg transform transition-transform ${
//           isSidebarOpen ? "translate-x-0" : "translate-x-full"
//         } sm:w-1/2`}
//       >
      
//         <button
//           className="absolute top-4 right-4 text-white hover:text-red-500 transition"
//           onClick={toggleSidebar}
//         >
//           <FiX className="w-6 h-6" />
//         </button>

//         <h2 className="font-semibold text-white text-lg mb-6 mt-10">Settings & Activity</h2>
//         <nav className="">
//           <Link to="/dashboard" className="flex items-center text-white hover:text-primary border-b border-white/30 py-3">
//             <FiHome className="mr-3 w-5 h-5 text-primary" />
//             Dashboard
//           </Link>
//           <Link to="/edit-profile" className="flex items-center text-white hover:text-primary border-b border-white/30 py-3">
//             <FiEdit className="mr-3 w-5 h-5 text-primary" />
//             Edit Profile
//           </Link>
//           <Link to="#" className="flex items-center text-white hover:text-primary border-b border-white/30 py-3">
//             <FiList className="mr-3 w-5 h-5 text-primary" />
//             My Tools
//           </Link>
//           <Link to="#" className="flex items-center text-white hover:text-primary border-b border-white/30 py-3">
//             <FiList className="mr-3 w-5 h-5 text-primary" />
//             Collections
//           </Link>
//           <Link to="/about-us" className="flex items-center text-white hover:text-primary border-b border-white/30 py-3">
//             <FiInfo className="mr-3 w-5 h-5 text-primary" />
//             About
//           </Link>
//           <Link to="/terms" className="flex items-center text-white hover:text-primary border-b border-white/30 py-3">
//             <FiFileText className="mr-3 w-5 h-5 text-primary" />
//             Terms
//           </Link>
//           <Link to="/privacy" className="flex items-center text-white hover:text-primary border-b border-white/30 py-3">
//             <FiShield className="mr-3 w-5 h-5 text-primary" />
//             Privacy & Policies
//           </Link>
//         </nav>

  
//         <div className="mt-6">
//           <button
//             className="w-full py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition flex items-center justify-center"
//           >
//             <Link to="/login"  className="flex">
//             <FiLogOut className="mr-2 w-5 h-5" />
//             Logout
//             </Link>
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ProfileSidebarMenu;



import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FiHome,
  FiEdit,
  FiTool,
  FiList,
  FiInfo,
  FiFileText,
  FiShield,
  FiX,
  FiLogOut,
} from "react-icons/fi";
import { removeStoredData } from "../../config/crypto";
import { BiSolidOffer } from "react-icons/bi";

const ProfileSidebarMenu = ({ isSidebarOpen, toggleSidebar }) => {
  
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    // Perform logout logic here (e.g., clear auth tokens, make API call)
    console.log("User logged out");
    setShowLogoutConfirm(false);
    removeStoredData('user')
    removeStoredData('token')
    navigate("/login"); // Redirect after logout
  };

  return (
    <>
      {/* Overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 transition-opacity"
          onClick={toggleSidebar}
        ></div>
      )}

      {/* Sidebar */}
      <div
        className={`fixed inset-y-0 right-0 z-40 w-3/4 max-w-sm bg-background-back2 p-6 shadow-lg transform transition-transform ${
          isSidebarOpen ? "translate-x-0" : "translate-x-full"
        } sm:w-1/2`}
      >
        {/* Close Icon */}
        <button
          className="absolute top-4 right-4 text-white hover:text-red-500 transition"
          onClick={toggleSidebar}
        >
          <FiX className="w-6 h-6" />
        </button>

        <h2 className="font-semibold text-white text-lg mb-6 mt-10">Settings & Activity</h2>
        <nav className="">
          {/* <Link to="/dashboard" className="flex items-center text-white hover:text-primary border-b border-white/30 py-3">
            <FiHome className="mr-3 w-5 h-5 text-primary" />
            Dashboard
          </Link> */}
          <Link to="/edit-profile" className="flex items-center text-white hover:text-primary border-b border-white/30 py-3">
            <FiEdit className="mr-3 w-5 h-5 text-primary" />
            Edit Profile
          </Link>
          <Link to="/coupons" className="flex items-center text-white hover:text-primary border-b border-white/30 py-3">
            <BiSolidOffer  className="mr-3 w-5 h-5 text-primary" />
            Coupons
          </Link>
          {/* <Link to="#" className="flex items-center text-white hover:text-primary border-b border-white/30 py-3">
            <FiList className="mr-3 w-5 h-5 text-primary" />
            My Tools
          </Link> */}
          {/* <Link to="#" className="flex items-center text-white hover:text-primary border-b border-white/30 py-3">
            <FiList className="mr-3 w-5 h-5 text-primary" />
            Collections
          </Link> */}
          <Link to="/about-us" className="flex items-center text-white hover:text-primary border-b border-white/30 py-3">
            <FiInfo className="mr-3 w-5 h-5 text-primary" />
            About
          </Link>
          <Link to="/terms" className="flex items-center text-white hover:text-primary border-b border-white/30 py-3">
            <FiFileText className="mr-3 w-5 h-5 text-primary" />
            Terms
          </Link>
          <Link to="/privacy" className="flex items-center text-white hover:text-primary border-b border-white/30 py-3">
            <FiShield className="mr-3 w-5 h-5 text-primary" />
            Privacy & Policies
          </Link>
        </nav>

        {/* Logout Button */}
        <div className="mt-6">
          <button
            className="border-2 w-full flex justify-center border-customBlue px-4 py-2 rounded text-white hover:bg-background-primary transition text-[15px] font-bold uppercase"
            onClick={() => setShowLogoutConfirm(true)}
          >
            <FiLogOut className="mr-2 w-5 h-5" />
            Logout
          </button>
        </div>
      </div>

      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-background-back2 p-6 rounded-lg shadow-lg w-80 text-center">
            <h3 className="text-lg font-semibold mb-4 text-white">Are you sure?</h3>
            <p className="text-gray-600 mb-6 text-white">Do you really want to log out?</p>
            <div className="flex justify-center gap-4">
              <button
                className=" px-4 py-2 text-[15px] font-bold uppercase hover:bg-background-btn border-2 border-customBlue text-white font-semibold rounded shadow transition bg-background-primary"
                onClick={() => setShowLogoutConfirm(false)}
              >
                Cancel
              </button>
              <button
                className="border-2 border-customBlue px-4 py-2 rounded text-white hover:bg-background-primary transition text-[15px] font-bold uppercase"
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProfileSidebarMenu;
